// The code in this file will load on every page of your site

import wixWindow from 'wix-window';

$w.onReady(function () {
	// Write your code here
	// setInterval(() => {detectScreenSizeChange();},100);
	detectScreenSizeChange();
});

function detectScreenSizeChange(){
//  wixWindow.getBoundingRect()
//  .then(winInfo => {
//   let winWidth = winInfo.window.width;
//    if (winWidth < 1200){
//     //code
	
// 	$w("#column11").hide();
//   } else {
//     //code
// 	$w("#column11").show();
//   }
//  });
}